import React from 'react';
import { useLocalStorage } from 'utils/useLocalStorage';

const TasksFiltersContext = React.createContext();

function TasksFiltersProvider({ children }) {
  const [filters, setFilter] = useLocalStorage('tasks/filters', {});

  const handleChangeFilter = (filter) => {
    setFilter((state) => ({ ...state, ...filter }));
  };

  return (
    <TasksFiltersContext.Provider value={{ filters, handleChangeFilter }}>
      {children}
    </TasksFiltersContext.Provider>
  );
}

function useTasksFiltersContext() {
  const context = React.useContext(TasksFiltersContext);
  if (context === undefined) {
    throw new Error('useTasksFiltersContext must be used within a TasksFiltersProvider');
  }
  return context;
}

export { TasksFiltersProvider, useTasksFiltersContext };
